/* OPC Store JS — faithful port of the Whop template behaviour.
   One bundle in the cart at a time (pack + optional extras + shipping protection),
   persistent countdowns, self-moving strips are pure CSS. */
(function () {
  'use strict';
  var OPC = window.OPC || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ───────── money ───────── */
  function money(cents) {
    var v = (cents / 100).toFixed(2);
    var fmt = OPC.moneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*amount\s*\}\}/, v)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','))
      .replace(/<[^>]*>/g, '');
  }

  /* ───────── persistent countdowns (same logic as useDeadline) ───────── */
  function deadline(key, durationSec, onTick) {
    var sk = 'store_' + key;
    function read() { try { var v = localStorage.getItem(sk); var n = v ? parseInt(v, 10) : NaN; return isFinite(n) ? n : null; } catch (e) { return null; } }
    function write(d) { try { localStorage.setItem(sk, String(d)); } catch (e) { } }
    var dl = read();
    var now = Date.now();
    if (dl === null || dl <= now) { dl = now + durationSec * 1000; write(dl); }
    function tick() {
      var n = Date.now();
      if (dl <= n) { dl = n + durationSec * 1000; write(dl); }
      onTick(Math.max(0, Math.round((dl - n) / 1000)));
    }
    tick();
    return setInterval(tick, 1000);
  }
  function pad(n) { return String(n).padStart(2, '0'); }
  function hms(sec) { return [Math.floor(sec / 3600), Math.floor((sec % 3600) / 60), sec % 60].map(pad); }

  $$('[data-timeboxes]').forEach(function (el) {
    var dur = parseInt(el.getAttribute('data-duration'), 10) || 13652;
    var h = $('[data-tb="h"]', el), m = $('[data-tb="m"]', el), s = $('[data-tb="s"]', el);
    deadline(el.getAttribute('data-timer-key') || 'sale', dur, function (sec) {
      var p = hms(sec); h.textContent = p[0]; m.textContent = p[1]; s.textContent = p[2];
    });
  });
  $$('[data-offer-clock]').forEach(function (el) {
    var dur = parseInt(el.getAttribute('data-duration'), 10) || 16339;
    deadline(el.getAttribute('data-timer-key') || 'offer', dur, function (sec) {
      el.textContent = hms(sec).join(':');
    });
  });

  /* ───────── drawers ───────── */
  function drawer(openBtns, closeBtns, panel, overlay) {
    function open() { panel.classList.add('is-open'); overlay.classList.add('is-open'); }
    function close() { panel.classList.remove('is-open'); overlay.classList.remove('is-open'); }
    openBtns.forEach(function (b) { b.addEventListener('click', open); });
    closeBtns.forEach(function (b) { b.addEventListener('click', close); });
    overlay.addEventListener('click', close);
    return { open: open, close: close };
  }
  var menuPanel = $('[data-menu-drawer]'), menuOverlay = $('[data-menu-overlay]');
  if (menuPanel && menuOverlay) {
    var menu = drawer($$('[data-menu-open]'), $$('[data-menu-close]'), menuPanel, menuOverlay);
    $$('[data-menu-link]').forEach(function (a) { a.addEventListener('click', menu.close); });
  }
  var cartPanel = $('[data-cart-drawer]'), cartOverlay = $('[data-cart-overlay]');
  var cartUI = null;
  if (cartPanel && cartOverlay) {
    cartUI = drawer($$('[data-cart-open]'), $$('[data-cart-close], [data-cart-close-shop]'), cartPanel, cartOverlay);
  }

  /* ───────── accordions (details + FAQ), all closed by default ───────── */
  $$('[data-acc-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var body = btn.nextElementSibling;
      var ico = $('.acc-ico', btn);
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      if (body) body.hidden = open;
      if (ico) ico.textContent = open ? '+' : '−';
    });
  });

  /* ───────── gallery ───────── */
  $$('[data-gallery]').forEach(function (gal) {
    var slides = $$('[data-slide]', gal);
    var thumbs = $$('[data-gal-thumb]', gal);
    var idx = 0;
    function show(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === idx); });
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === idx); });
    }
    var prev = $('[data-gal-prev]', gal), next = $('[data-gal-next]', gal);
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
    thumbs.forEach(function (t, j) { t.addEventListener('click', function () { show(j); }); });
  });

  /* ───────── packs: selection + extras reset on switch ───────── */
  var packs = $$('[data-pack]');
  function activePack() { return $('[data-pack].is-active') || packs[0]; }
  packs.forEach(function (card) {
    function select() {
      if (card.classList.contains('is-active')) return;
      packs.forEach(function (c) {
        c.classList.remove('is-active');
        c.setAttribute('aria-pressed', 'false');
        $$('input[data-extra]', c).forEach(function (cb) { cb.checked = false; });
      });
      card.classList.add('is-active');
      card.setAttribute('aria-pressed', 'true');
    }
    card.addEventListener('click', function (e) {
      if (e.target.closest('[data-extra-row]')) return; // clicks on extras don't switch pack
      select();
    });
    card.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && !e.target.closest('[data-extra-row]')) { e.preventDefault(); select(); }
    });
  });

  /* ───────── cart (one bundle at a time, like the template) ───────── */
  function fetchCart() { return fetch(OPC.routes.cart, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function clearCart() { return fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } }); }
  function addItems(items) {
    return fetch(OPC.routes.add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
  }

  var cartClockTimer = null;
  function startCartClock() {
    var el = $('[data-cart-clock]');
    if (!el || cartClockTimer) return;
    cartClockTimer = deadline('cart', OPC.cartTimerSeconds || 300, function (sec) {
      el.textContent = pad(Math.floor(sec / 60)) + ':' + pad(sec % 60);
    });
  }

  function protectionOn() {
    var t = $('[data-protection-toggle]');
    return !!(t && t.checked);
  }

  var lastCount = null; // item_count from the last render; lets addBundle skip the clear call

  function renderCart(cart) {
    lastCount = cart.item_count;
    var body = $('[data-cart-body]');
    var foot = $('[data-cart-foot]');
    var empty = $('[data-cart-empty]');
    var savedRow = $('[data-cart-saved-row]');
    var count = $('[data-cart-count]');
    if (!body) return;

    var prodIds = (OPC.product ? OPC.product.variants.map(function (v) { return v.id; }) : []);
    var protId = OPC.protection ? OPC.protection.variantId : null;
    var mystery = OPC.upsells && OPC.upsells.mystery;
    var warranty = OPC.upsells && OPC.upsells.warranty;

    var packLine = null, extraLines = [], protLine = null;
    (cart.items || []).forEach(function (it) {
      if (prodIds.indexOf(it.variant_id) !== -1) packLine = it;
      else if (protId && it.variant_id === protId) protLine = it;
      else if ((mystery && it.variant_id === mystery.variantId) || (warranty && it.variant_id === warranty.variantId)) extraLines.push(it);
    });

    if (count) {
      count.textContent = cart.item_count;
      count.hidden = cart.item_count === 0;
    }

    // Sync the switch with the cart ONLY when a bundle is in it; with an empty cart
    // it stays ON (default), so the next add-to-cart includes the protection.
    var toggle = $('[data-protection-toggle]');
    if (toggle && packLine) toggle.checked = !!protLine;
    if (toggle && !packLine) toggle.checked = true;

    if (!packLine) {
      body.innerHTML = '';
      foot.hidden = true;
      empty.hidden = false;
      savedRow.hidden = true;
      return;
    }
    empty.hidden = true;
    foot.hidden = false;
    savedRow.hidden = false;
    startCartClock();

    var units = prodIds.indexOf(packLine.variant_id) + 1;
    var packText = (OPC.text.packLine || '{U}-pack × {Q}').replace('{U}', units).replace('{Q}', packLine.quantity);
    var lineTotal = packLine.line_price + extraLines.reduce(function (a, it) { return a + it.line_price; }, 0);

    var html = '<div class="cart-line">';
    html += '<img src="' + (packLine.image || OPC.product.image || '') + '" alt="" width="56" height="70">';
    html += '<div class="l-info">';
    html += '<p>' + OPC.product.title + '</p>';
    html += '<p>' + packText + '</p>';
    html += '<p>+ ' + OPC.text.giftLabel + '</p>';
    extraLines.forEach(function (it) { html += '<p>+ ' + it.product_title + '</p>'; });
    html += '<p class="l-price">' + money(lineTotal) + '</p>';
    html += '</div>';
    html += '<button class="l-remove" type="button" data-cart-remove aria-label="' + OPC.text.remove + '">✕</button>';
    html += '</div>';
    body.innerHTML = html;

    var rm = $('[data-cart-remove]', body);
    if (rm) rm.addEventListener('click', function () {
      clearCart().then(function () { return fetchCart(); }).then(renderCart);
    });

    // You save = (compareAt − price) × qty of the chosen pack
    var v = OPC.product.variants[units - 1];
    var savings = v && v.compareAt > v.price ? (v.compareAt - v.price) * packLine.quantity : 0;
    var sEl = $('[data-cart-savings]'); if (sEl) sEl.textContent = money(savings);
    var tEl = $('[data-cart-total]'); if (tEl) tEl.textContent = money(cart.total_price);
  }

  function addBundle(extras) {
    if (!OPC.product) return Promise.resolve();
    var card = activePack();
    var variantId = parseInt(card.getAttribute('data-variant'), 10);
    var items = [{ id: variantId, quantity: 1 }];
    (extras || []).forEach(function (key) {
      var u = OPC.upsells && OPC.upsells[key];
      if (u) items.push({ id: u.variantId, quantity: 1 });
    });
    if (OPC.protection && protectionOn()) items.push({ id: OPC.protection.variantId, quantity: 1 });

    // Open the drawer right away with a loading state: the network finishes behind it
    var body = $('[data-cart-body]');
    var empty = $('[data-cart-empty]');
    if (empty) empty.hidden = true;
    if (body) body.innerHTML = '<p class="cart-loading">' + (OPC.text.adding || 'Adding to cart…') + '</p>';
    if (cartUI) cartUI.open();

    // Skip the clear round-trip when the cart is already empty (first add)
    var start = (lastCount === 0) ? Promise.resolve() : clearCart();
    return start
      .then(function () { return addItems(items); })
      .then(function () { return fetchCart(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function () { return fetchCart().then(renderCart).catch(function () { }); });
  }

  var atc = $('[data-atc]');
  if (atc) atc.addEventListener('click', function () {
    var card = activePack();
    var extras = [];
    $$('input[data-extra]', card).forEach(function (cb) { if (cb.checked) extras.push(cb.getAttribute('data-extra')); });
    atc.disabled = true;
    addBundle(extras).then(function () { atc.disabled = false; });
  });

  var sticky = $('[data-sticky-add]');
  if (sticky) sticky.addEventListener('click', function () {
    sticky.disabled = true;
    addBundle([]).then(function () { sticky.disabled = false; });
  });

  // Shipping Protection switch inside the drawer: adds/removes the protection line
  var protToggle = $('[data-protection-toggle]');
  if (protToggle) protToggle.addEventListener('change', function () {
    if (!OPC.protection) return;
    var want = protToggle.checked;
    protToggle.disabled = true;
    fetchCart().then(function (cart) {
      var line = (cart.items || []).filter(function (it) { return it.variant_id === OPC.protection.variantId; })[0];
      if (want && !line) return addItems([{ id: OPC.protection.variantId, quantity: 1 }]);
      if (!want && line) {
        return fetch(OPC.routes.change, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: String(line.key), quantity: 0 })
        });
      }
    }).then(function () { return fetchCart(); }).then(function (cart) {
      renderCart(cart); protToggle.disabled = false;
    }).catch(function () { protToggle.disabled = false; });
  });

  // Initial paint of the drawer from the live cart; ?cart=1 reopens it (back from checkout)
  fetchCart().then(function (cart) {
    renderCart(cart);
    try {
      if (new URLSearchParams(window.location.search).get('cart') === '1' && cartUI) cartUI.open();
    } catch (e) { }
  }).catch(function () { });

  /* ───────── customs ID (MX/CO): required before checkout, saved as cart attribute ───────── */
  (function () {
    var rule = OPC.taxId;
    var block = $('[data-taxid]');
    if (!rule || !block) return;
    block.hidden = false;
    $('[data-taxid-label]', block).textContent = rule.label;
    $('[data-taxid-hint]', block).textContent = rule.hint;
    var input = $('[data-taxid-input]', block);
    var err = $('[data-taxid-err]', block);
    var re = new RegExp(rule.pattern);
    var norm = function (v) { return String(v || '').toUpperCase().replace(/[\s.]/g, '').slice(0, 30); };
    var checkout = $('[data-cart-checkout]');
    if (checkout) checkout.addEventListener('click', function (e) {
      var v = norm(input.value);
      if (!re.test(v)) {
        e.preventDefault();
        err.textContent = rule.hint;
        err.hidden = false;
        input.focus();
        return;
      }
      err.hidden = true;
      e.preventDefault();
      var attrs = {};
      attrs[rule.attr] = v;
      fetch(OPC.routes.update, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).then(function () { window.location.href = '/checkout'; })
        .catch(function () { window.location.href = '/checkout'; });
    });
  })();

  /* ───────── reviews: show more (+12) ───────── */
  $$('[data-reviews]').forEach(function (sec) {
    var per = parseInt(sec.getAttribute('data-per'), 10) || 12;
    var visible = per;
    var btn = $('[data-rv-more]', sec);
    if (!btn) return;
    btn.addEventListener('click', function () {
      visible += per;
      var items = $$('[data-rv]', sec);
      items.forEach(function (it, i) { it.classList.toggle('is-hidden', i >= visible); });
      if (visible >= items.length) btn.parentElement.hidden = true;
    });
  });

  /* ───────── reviews: once the page has loaded, fetch the visible review photos in the background
     so they are already there when the visitor scrolls down (cards behind Show more still wait) ───────── */
  (function () {
    var conn = navigator.connection;
    if (conn && conn.saveData) return;
    var warm = function () {
      $$('[data-reviews] img[loading="lazy"]').forEach(function (img) {
        if (!img.closest('.is-hidden')) img.loading = 'eager';
      });
    };
    var start = function () {
      if (window.requestIdleCallback) window.requestIdleCallback(warm, { timeout: 3000 });
      else setTimeout(warm, 1200);
    };
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
  })();

  /* ───────── contact: prefilled mailto ───────── */
  $$('[data-contact-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.getAttribute('data-email') || '';
      var f = function (n) { return (form.elements[n] && form.elements[n].value || '').trim(); };
      var subject = (form.getAttribute('data-subject') || 'Contact') + (f('order') ? ' · #' + f('order') : '') + ' · ' + f('name');
      var bodyTxt = f('message') + '\n\n' + f('name') + '\n' + f('email') + (f('order') ? '\nOrder: ' + f('order') : '');
      window.location.href = 'mailto:' + email + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(bodyTxt);
      var ok = $('[data-contact-ok]', form.parentElement);
      if (ok) ok.hidden = false;
    });
  });

  /* ───────── floating pickers (country/currency + language) ───────── */
  $$('[data-float-pick]').forEach(function (pick) {
    var btn = $('[data-float-btn]', pick);
    var menuEl = $('.float-menu', pick);
    if (!btn || !menuEl) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      menuEl.hidden = !menuEl.hidden;
    });
    document.addEventListener('click', function () { menuEl.hidden = true; });
    $$('button[data-country]', menuEl).forEach(function (b) {
      b.addEventListener('click', function () {
        var form = b.closest('form');
        $('[data-country-field]', form).value = b.getAttribute('data-country');
        form.submit();
      });
    });
    $$('button[data-locale]', menuEl).forEach(function (b) {
      b.addEventListener('click', function () {
        try { localStorage.setItem('opc_pref_lang', b.getAttribute('data-locale').slice(0, 2)); } catch (e) { }
        var form = b.closest('form');
        $('[data-locale-field]', form).value = b.getAttribute('data-locale');
        form.submit();
      });
    });
  });
})();
